import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import MobileHero from "../Components/mobile/MobileHero";
import MobileServices from "../Components/mobile/MobileServices";
import MobileProcess from "../Components/mobile/MobileProcess";
import MobileTechWork from "../Components/mobile/MobileTechWork";
import MobileCta from "../Components/mobile/MobileCta";

// Redesigned (Tailwind) page for /service/mobile-app-design-development-solutions.
const MobileAppPage = () => (
  <div>
    <SEOPage
      title="Mobile App Development Company in Noida | iOS, Android & Flutter Apps | DataMetricks"
      description="DataMetricks builds high-performing, scalable and user-centric mobile apps for iOS and Android using Swift, Kotlin, Flutter and React Native, from idea to app store launch and beyond."
      canonicalUrl="https://www.datametricks.com/service/mobile-app-design-development-solutions"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <MobileHero />
      <MobileServices />
      <MobileProcess />
      <MobileTechWork />
      <MobileCta />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default MobileAppPage;
